var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('Header'),_c('router-view')],1),_c('notifications',{attrs:{"group":"alert","position":"bottom right","classes":"notification-style"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }